// extracted by mini-css-extract-plugin
module.exports = {"power-independence-P":"P_power-independence-P__658pu"};